import { AccountBrand, AccountConfig } from '@betterfunnel/types';
import { collection, doc, setDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../Firebase';

export const updateAccountBrand = async (
  accountId: string,
  data: Partial<AccountBrand>,
) => {
  const accountsColRef = collection(db, 'accounts');
  const accountRef = doc(accountsColRef, accountId);
  const accountBrandRef = doc(
    collection(accountRef, 'accountBrand'),
    'default',
  );

  return setDoc(accountBrandRef, data, { mergeFields: Object.keys(data) });
};

export const updateAccountConfig = async (
  accountId: string,
  data: Partial<AccountConfig>,
) => {
  const accountsColRef = collection(db, 'accounts');
  const accountRef = doc(accountsColRef, accountId);
  const accountConfigRef = doc(
    collection(accountRef, 'accountConfig'),
    'default',
  );

  const mergeFields = Object.entries(data).flatMap(([key, value]) => {
    if (key === 'seo') {
      const subFields = Object.keys(value);
      return subFields.map((subField) => `${key}.${subField}`);
    }

    return key;
  });

  return setDoc(accountConfigRef, data, { mergeFields: mergeFields });
};

export const getSSOAuthProvider = async (email: string) => {
  const fn = httpsCallable(functions, 'accounts-getSsoAuthProvider');
  const res = await fn({ email });

  return res.data;
};

export const createAccountAccessToken = async (
  accountId: string,
): Promise<string> => {
  const fn = httpsCallable<any, any>(
    functions,
    'accounts-accessTokens-createToken',
  );
  const res = await fn({ accountId, type: 'customer' });

  return res.data.token;
};
